import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Table, TableBody, TableCell, TableHead, TableRow,  Box, Grid, TextField, AppBar, FormControl, Select, MenuItem, Typography, Button } from '@mui/material';
import NavBar from '../Navigation/Navigation';
//import PrintTagsButton from './PrintTags';


interface PriceChangeDetails {
 Location_ID: string;
 createdLocation: string;
 Price_Change_No : string;
  PLU_SKU: string;
  Description_1: string;
  Style_Code: string;
  Size1_Code: string;
  Color_Code: string;
   Prepared_Date: string | "";
  Approved_Date: string | "";
  Applied_Date:string | "";
  Original_Retail: number; 
  Value: number;
  Org_Selling_Price : number;
  QTY_On_Hand: number;
  Average_Cost: number;
  Aged_Days : number;
  Notes: string;
  Status: string;
}

const PriceChangeItems: React.FC = () => {
    const { priceChangeNo } = useParams<{ priceChangeNo: string}>(); // Extract all params
  const [PriceChangeItems, setPriceChangeItems] = useState<PriceChangeDetails[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [filterKey, setFilterKey] = useState<'PLU_SKU' | 'Style_Code' | 'Size1_Code' | 'Description_1'>('Style_Code'); // Added Description_1 for filtering
  const [searchValue, setSearchValue] = useState<string>(''); // Search value

  // Fetch transfer details using useEffect
  useEffect(() => {
    const fetchPriceChangeItems = async () => {
      setLoading(true);
      try {
        const response = await fetch('/pc/priceDropItems', {
          method: 'POST',
          credentials:'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ priceChangeNo}), // Send transferNo, SendingLocation, and receivingLocation
        });
        const data = await response.json();

      // ✅ FIX: data.records expected instead of direct data
      if (data && Array.isArray(data.records)) {
        setPriceChangeItems(data.records);
      } else {
        console.error("Unexpected API format:", data);
        setPriceChangeItems([]); // fallback
      }

    } catch (error) {
      console.error('Error fetching price change items:', error);
      setPriceChangeItems([]); // fallback
    } finally {
      setLoading(false);
    }
  };

  fetchPriceChangeItems();
}, [priceChangeNo]);
  
  // Aggregated function to calculate total quantities
  const getTotalQty = (key: 'QTY_On_Hand') => {
    return PriceChangeItems.reduce((total, detail) => total + (detail[key] || 0), 0);
  };

 // Filter the transfer details based on the searchValue and filterKey
 const filteredDetails = PriceChangeItems.filter((detail) =>
    detail[filterKey].toString().toLowerCase().includes(searchValue.toLowerCase())
  );

  // Fetch aggregated data
  const totalQtySend = getTotalQty('QTY_On_Hand');
  
  const [reprintQuantities, setReprintQuantities] = useState<{ [key: string]: number }>({});

    const filteredItems = PriceChangeItems.filter((PriceChangeItems) =>
    PriceChangeItems.PLU_SKU.toLowerCase().includes(searchValue.toLowerCase()) ||
   PriceChangeItems.Description_1.toLowerCase().includes(searchValue.toLowerCase())
  );

 const handlePrintTags = async () => {
  try {
    // Step 1: Group items by Style_Code + Size1_Code
    const grouped: { [key: string]: { sku: string; qty: number } } = {};

    for (const item of filteredItems) {
      const key = `${item.Style_Code}||${item.Size1_Code}`;
      const qty = reprintQuantities[item.PLU_SKU] || 0;

      if (!grouped[key]) {
        grouped[key] = {
          sku: item.PLU_SKU, // use the first SKU as representative
          qty :  item.QTY_On_Hand,
        };
      } else {
        grouped[key].qty += qty;
      }
    }

    // Step 2: Send only one print request per group
    for (const key in grouped) {
      const { sku, qty } = grouped[key];
      if (qty < 1) continue;

      const response = await fetch('/print-label', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sku,
          qty,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        sendZplToPrinter(data.zpl);
      } else {
        console.error(`Failed to print label for group ${key}:`, data.message);
      }
    }
  } catch (error) {
    console.error('Error printing tags:', error);
  }
};



  const sendZplToPrinter = (zpl: string) => {
    window.BrowserPrint.getLocalDevices((devices: any) => {
      console.log('Devices object:', devices);

      // Access the 'printer' array inside the 'devices' object
      if (devices && devices.printer && Array.isArray(devices.printer)) {
        const printers = devices.printer;

        console.log('Printers array length:', printers.length);

        // Check if there are any printers connected
        if (printers.length > 0) {
          printers.forEach((printer: any) => {
            console.log(`Printer: ${printer.name}, Connection: ${printer.connection}`);
          });

          // Find the USB-connected printer
          const printer = printers.find((device: any) => device.connection === 'usb');

          if (printer) {
            console.log('USB printer selected:', printer);
            // Now send ZPL to this printer
            printer.send(
              zpl,
              () => {
                //alert('Label sent to printer successfully.');
              },
              (error: string) => {
                console.error('Error sending ZPL to printer:', error);
                alert('Error sending label to printer: ' + error);
              }
            );
          } else {
            console.log('No USB-connected Zebra printer found.');
            alert('No USB-connected Zebra printer found.');
          }
        } else {
          console.log('No printers found.');
          alert('No printers found. Please check your printer connection.');
        }
      } else {
        console.error('No printers found in the devices object:', devices);
        alert('No printers found.');
      }
    }, 'printer');

  }

  return (
    <>
      <AppBar position="sticky">
        <NavBar />
      </AppBar>
      <Box sx={{paddingTop:0.3,height: '88vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', backgroundColor:'#ccc' }}>
        {/* Top section: 30% - Aggregated Information */}
        <Box
          sx={{
            backgroundColor: '#f5f5f5',
           paddingTop:1.5,
            borderRadius: '5px',
            height: '30%',
            overflowY: 'auto', // Make top section scrollable
            borderBottom: '1px solid #ccc',
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="PC_No #"
                variant="outlined"
                fullWidth
                value={PriceChangeItems[0]?.Price_Change_No || ''}
                size="small" // Reduces the size of the input field
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                  
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="Location"
                variant="outlined"
                fullWidth
                value={PriceChangeItems[0]?.Location_ID || ''}
                size="small"
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="CreatedLocation"
                variant="outlined"
                fullWidth
                value={PriceChangeItems[0]?.createdLocation || ''}
                size="small"
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="Prepared Date"
                variant="outlined"
                fullWidth
                size="small"
                value={new Date(PriceChangeItems[0]?.Prepared_Date).toLocaleString() || ''}
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="Approved Date"
                variant="outlined"
                fullWidth
                size="small"
                value={PriceChangeItems[0]?.Approved_Date ? new Date(PriceChangeItems[0]?.Approved_Date).toLocaleString() : ''}
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }}
              />
            </Grid>

              <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="Applied Date"
                variant="outlined"
                fullWidth
                size="small"
                value={PriceChangeItems[0]?.Applied_Date ? new Date(PriceChangeItems[0]?.Applied_Date).toLocaleString() : ''}
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="Total Qty"
                variant="outlined"
                fullWidth
                size="small"
                value={totalQtySend}
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }}
              />
            </Grid>

            {/* <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="Total Qty Received"
                variant="outlined"
                fullWidth
                size="small"
                value={totalQtyReceived}
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }}
              />
            </Grid> */}

            <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="Status"
                variant="outlined"
                fullWidth
                size="small"
                value={PriceChangeItems[0]?.Status || ''}
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }}
              />
            </Grid>

            {/* <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="List Notes"
                variant="outlined"
                fullWidth
                size="small"
                value={PriceChangeItems[0]?.Notes || 'N/A'}
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }}
              />
            </Grid> */}

            <Grid item xs={12} sm={4} md={4}>
              <TextField
                label="Notes"
                variant="outlined"
                fullWidth
                size="small"
                value={PriceChangeItems[0]?.Notes || 'N/A'}
                InputProps={{
                  readOnly: true,
                  sx: { height: 36 }, // Customize the input height
                }}
                InputLabelProps={{ style: { fontWeight: 'bold',fontFamily: 'Arial', fontSize:'14pt' } }} // Bold label
              />
            </Grid>
          </Grid>
        </Box>
                 {/* Search Section */}
        <Box sx={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #ccc', padding:1 }}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography sx={{ fontWeight: 'bold', fontSize: '11pt' }}>Search by</Typography>
                <Select
                  value={filterKey}
                  onChange={(e) => setFilterKey(e.target.value as 'PLU_SKU' | 'Style_Code' | 'Size1_Code' | 'Description_1')}
                  size="small" // Reducing the size of the select component
                  sx={{ height: 36 }} // Minimum height
                >
                  <MenuItem value="PLU_SKU">SKU</MenuItem>
                  <MenuItem value="Style_Code">Style Code</MenuItem>
                  <MenuItem value="Size1_Code">Size</MenuItem>
                  <MenuItem value="Description_1">Description</MenuItem> {/* New filter option */}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
              <TextField
                fullWidth
                label="Search"
                variant="outlined"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                size="small" // Reducing the size of the input field
                sx={{ height: 36, marginTop:'20px' }} // Minimum height
                InputLabelProps={{ style: { fontWeight: 'bold', fontSize: '14pt' } }} // Bold label with 12pt
              />``
                     <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', marginTop:'20px', marginLeft: '50px' }}>
              {/* Adding the PrintTagsButton with the transferNo */}
              <Button variant="contained" color="primary" onClick={handlePrintTags}>
                Print All Tags
              </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        {/* Bottom section: 70% - Detailed SKU Information */}
        <Box sx={{ height: '80%', overflowY: 'auto' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {['SKU', 'Description', 'Style Code', 'Color', 'Size', 'QTY_On_Hand', 'Average_Cost', 'Value', 'Original_Retail','Org_Selling_Price','Aged_Days'].map((header) => (
                  <TableCell key={header} sx={{ backgroundColor: '#FFFFF0', border: '1px solid #ccc', fontWeight: 'bold', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredDetails.map((detail, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: index % 2 === 0 ? '#FAF9F6' : '#D3D3D3',
                    '&:hover': {
                      backgroundColor: '#E0E0E0',
                    },
                  }}
                >
                  <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>{detail.PLU_SKU}</TableCell>
                  <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>{detail.Description_1}</TableCell>
                  <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>{detail.Style_Code}</TableCell>
                  <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>{detail.Color_Code}</TableCell>
                  <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>{detail.Size1_Code}</TableCell>
                  <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>{detail.QTY_On_Hand}</TableCell>
                  <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>${detail.Average_Cost}</TableCell>
                  <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>${detail.Value}</TableCell>
                  <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>${detail.Original_Retail}</TableCell>
                  <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>${detail.Org_Selling_Price}</TableCell>
                   <TableCell sx={{ border: '1px solid #ccc', fontSize: '12pt', fontFamily: 'Arial', padding: '5px' }}>{detail.Aged_Days}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>

       
      </Box>
    </>
  );
};

export default PriceChangeItems;
